const API_BASE_URL = process.env.REACT_APP_BACKEND_API || 'https://kidbackend.codingindia.co.in';

export default API_BASE_URL;
